var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLandscape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 410",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "\u0130K uygulamas\u0131 login arka plan g\xF6rseli") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Y\xFCkselen g\xFCne\u015F, sakin g\xF6l, yelkenli ve g\xF6ky\xFCz\xFCnde \xF6zg\xFCrce u\xE7an ku\u015Flar\u0131n yer ald\u0131\u011F\u0131 ilham verici sabah manzaras\u0131"), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c1830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38%",
    stopColor: "#1a3468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "68%",
    stopColor: "#3d608c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#a06840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d99030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lake",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c2240"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060e1c"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 680,
    height: 248,
    fill: "url(#sky)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 45,
    r: 1.5,
    fill: "#f0e090",
    opacity: 0.85,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.85,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 28,
    r: 1,
    fill: "#f0e090",
    opacity: 0.75,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.75,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 62,
    r: 1.3,
    fill: "#f0e090",
    opacity: 0.65,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.65,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 38,
    r: 1,
    fill: "#f0e090",
    opacity: 0.7,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 95,
    r: 1.1,
    fill: "#f0e090",
    opacity: 0.55,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 85,
    r: 1.4,
    fill: "#f0e090",
    opacity: 0.6,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 118,
    r: 1,
    fill: "#f0e090",
    opacity: 0.5,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 52,
    r: 1,
    fill: "#f0e090",
    opacity: 0.55,
    style: {
      fill: "rgb(240, 224, 144)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 245,
    r: 80,
    fill: "#f0a02806",
    style: {
      fill: "rgba(240, 160, 40, 0.024)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 245,
    r: 58,
    fill: "#f0a02812",
    style: {
      fill: "rgba(240, 160, 40, 0.07)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 245,
    r: 40,
    fill: "#f0a02820",
    style: {
      fill: "rgba(240, 160, 40, 0.125)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 245,
    r: 26,
    fill: "#f5b030",
    style: {
      fill: "rgb(245, 176, 48)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 245,
    r: 19,
    fill: "#ffd050",
    style: {
      fill: "rgb(255, 208, 80)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334,
    cy: 239,
    r: 7,
    fill: "#ffe880",
    opacity: 0.5,
    style: {
      fill: "rgb(255, 232, 128)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 248 L0 215 L55 158 L115 200 L175 152 L238 196 L282 172 L322 218 L340 248 Z",
    fill: "#172848",
    style: {
      fill: "rgb(23, 40, 72)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 248 L358 218 L398 175 L452 202 L506 162 L562 196 L618 158 L680 208 L680 248 Z",
    fill: "#172848",
    style: {
      fill: "rgb(23, 40, 72)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 156 L175 152 L198 158 L175 168 Z",
    fill: "#8090a8",
    opacity: 0.18,
    style: {
      fill: "rgb(128, 144, 168)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.18,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 166 L506 162 L528 168 L506 178 Z",
    fill: "#8090a8",
    opacity: 0.18,
    style: {
      fill: "rgb(128, 144, 168)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.18,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 244,
    width: 680,
    height: 156,
    fill: "url(#lake)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 244,
    x2: 680,
    y2: 244,
    stroke: "#d09030",
    strokeWidth: 0.8,
    opacity: 0.3,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(208, 144, 48)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 245,
    width: 28,
    height: 155,
    fill: "#f5b03014",
    rx: 2,
    style: {
      fill: "rgba(245, 176, 48, 0.08)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332,
    y: 245,
    width: 16,
    height: 155,
    fill: "#f5b03022",
    rx: 1,
    style: {
      fill: "rgba(245, 176, 48, 0.133)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 245,
    width: 6,
    height: 155,
    fill: "#ffd05032",
    style: {
      fill: "rgba(255, 208, 80, 0.196)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 278,
    rx: 52,
    ry: 4,
    fill: "none",
    stroke: "#f5b03018",
    strokeWidth: 1,
    style: {
      fill: "none",
      stroke: "rgba(245, 176, 48, 0.094)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 305,
    rx: 74,
    ry: 5,
    fill: "none",
    stroke: "#f5b03012",
    strokeWidth: 0.8,
    style: {
      fill: "none",
      stroke: "rgba(245, 176, 48, 0.07)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 338,
    rx: 100,
    ry: 6,
    fill: "none",
    stroke: "#f5b03008",
    strokeWidth: 0.8,
    style: {
      fill: "none",
      stroke: "rgba(245, 176, 48, 0.03)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 292,
    x2: 270,
    y2: 292,
    stroke: "#ffffff0a",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.04)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410,
    y1: 292,
    x2: 640,
    y2: 292,
    stroke: "#ffffff0a",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.04)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 325,
    x2: 255,
    y2: 325,
    stroke: "#ffffff07",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.027)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 425,
    y1: 325,
    x2: 620,
    y2: 325,
    stroke: "#ffffff07",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.027)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 360,
    x2: 240,
    y2: 360,
    stroke: "#ffffff05",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.02)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 360,
    x2: 600,
    y2: 360,
    stroke: "#ffffff05",
    strokeWidth: 0.8,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.02)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(472, 228)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24 17 Q0 23 24 17 L20 26 Q0 30 -20 26 Z",
    fill: "#09182c",
    style: {
      fill: "rgb(9, 24, 44)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 16,
    x2: 0,
    y2: -42,
    stroke: "#0c2038",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(12, 32, 56)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 15 L1 -40 L30 14 Z",
    fill: "#ddd6c8cc",
    style: {
      fill: "rgba(221, 214, 200, 0.8)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 9  L-1 -28 L-17 7  Z",
    fill: "#d0c9bc99",
    style: {
      fill: "rgba(208, 201, 188, 0.6)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2  L5 -33 L22 8   Z",
    fill: "#ffffff22",
    style: {
      fill: "rgba(255, 255, 255, 0.133)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -42 L9 -37 L0 -32 Z",
    fill: "#e8a030",
    style: {
      fill: "rgb(232, 160, 48)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22 28 Q0 32 22 28",
    fill: "none",
    stroke: "#ffffff14",
    strokeWidth: 0.8,
    style: {
      fill: "none",
      stroke: "rgba(255, 255, 255, 0.08)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.8px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148, 240)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9 6 Q0 10 9 6 L7 12 Q0 14 -7 12 Z",
    fill: "#152638",
    style: {
      fill: "rgb(21, 38, 56)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 5,
    x2: 0,
    y2: -16,
    stroke: "#152638",
    strokeWidth: 1,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(21, 38, 56)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4 L0 -14 L12 4 Z",
    fill: "#c4bdb455",
    style: {
      fill: "rgba(196, 189, 180, 0.333)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88  150 Q95  144 102 150",
    fill: "none",
    stroke: "#90b0d0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(144, 176, 208)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 141 Q114 134 122 141",
    fill: "none",
    stroke: "#90b0d0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(144, 176, 208)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 130 Q141 122 150 130",
    fill: "none",
    stroke: "#a0c0e0",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(160, 192, 224)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 120 Q166 111 176 120",
    fill: "none",
    stroke: "#a8c8e8",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(168, 200, 232)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.8px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 110 Q191 100 202 110",
    fill: "none",
    stroke: "#b4d0f0",
    strokeWidth: 2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(180, 208, 240)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 99  Q222  88 234  99",
    fill: "none",
    stroke: "#bcd8f8",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(188, 216, 248)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.2px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 86  Q258  74 272  86",
    fill: "none",
    stroke: "#c8e0ff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "rgb(200, 224, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 400 L0 360 L150 360 L150 400 Z",
    fill: "#060d18",
    style: {
      fill: "rgb(6, 13, 24)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 362 L26 330 L34 362 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 348 L26 318 L34 348 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 365 L45 334 L54 365 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 350 L45 322 L54 350 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 368 L67 340 L76 368 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 370 L89 345 L98 370 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 360 L680 360 L680 400 L530 400 Z",
    fill: "#060d18",
    style: {
      fill: "rgb(6, 13, 24)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 363 L555 332 L564 363 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 349 L555 320 L564 349 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 366 L577 338 L586 366 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590 369 L599 342 L608 369 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 364 L621 335 L630 364 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 367 L643 340 L652 367 Z",
    fill: "#040c16",
    style: {
      fill: "rgb(4, 12, 22)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLandscape);
export default __webpack_public_path__ + "static/media/login_landscape.c07959a8a62b2627105831ee0495847b.svg";
export { ForwardRef as ReactComponent };